import { BookingTabId } from 'components/Bookings2/Navbar/bookingTabs';

const STORAGE_PREFIX = 'bookings_tab_order';

export const getBookingTabStorageKey = (
    userId: number | undefined,
    marketplaceId: number | undefined
): string | undefined =>
    userId !== undefined && marketplaceId !== undefined ? `${STORAGE_PREFIX}:${userId}:${marketplaceId}` : undefined;

export const reconcileBookingTabOrder = (
    savedOrder: unknown,
    availableIds: Array<BookingTabId>
): Array<BookingTabId> => {
    if (!Array.isArray(savedOrder)) return availableIds;

    const knownSavedIds = savedOrder.filter(
        (id): id is BookingTabId => typeof id === 'string' && availableIds.includes(id as BookingTabId)
    );
    const uniqueSavedIds = knownSavedIds.filter((id, index) => knownSavedIds.indexOf(id) === index);
    const newIds = availableIds.filter(id => !uniqueSavedIds.includes(id));

    return [...uniqueSavedIds, ...newIds];
};

export const readBookingTabOrder = (
    storageKey: string | undefined,
    availableIds: Array<BookingTabId>
): Array<BookingTabId> => {
    if (!storageKey) return availableIds;

    try {
        const savedOrder = JSON.parse(localStorage.getItem(storageKey) ?? 'null');
        return reconcileBookingTabOrder(savedOrder, availableIds);
    } catch {
        return availableIds;
    }
};

export const saveBookingTabOrder = (storageKey: string | undefined, order: Array<BookingTabId>) => {
    if (!storageKey) return;

    try {
        localStorage.setItem(storageKey, JSON.stringify(order));
    } catch {
        // The preference remains in memory when browser storage is unavailable.
    }
};
